import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:7006/api';
const QQ_PORTAL = process.env.REACT_APP_QQ_PORTAL_URL || 'http://localhost:7001/my-tools';

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Inject Authorization Access Token to every request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('qq_token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: redirect to QuirkyQode SSO portal on 401/403
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('qq_token');
      window.location.href = QQ_PORTAL;
    }
    return Promise.reject(error);
  }
);
